import { Component } from '@angular/core';
import { Action } from '@kaiser-software/chassis-datatable';
import { RouteService } from '../../../../routing/services/route.service';

@Component({
    selector: 'chassis-datatable-show-action',
    templateUrl: './show.component.html',
    styleUrls: ['./show.component.scss'],
})
export class ShowComponent extends Action {

    constructor(
        protected routeService: RouteService
    ) {
        super();
    }

    public show(): void {
        console.log('Show', this.data, this.row);

        if (this.data.hasOwnProperty('baseRouteName')) {
            this.routeService.navigate(this.data.baseRouteName + '.show', this.data.id);
        }
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/resources/components/actions/show/show.component.ts